import React from 'react'
import styled from '@emotion/styled'
import { Star } from './star'

const Wrapper = styled.div`
  display: flex;
  flex-direction: ${({ direction }) => direction};
  justify-content: ${({ direction }) =>
    direction === 'row' ? 'space-between' : 'flex-start'};
  align-items: ${({ direction }) =>
    direction === 'row' ? 'center' : 'flex-start'};
  gap: 6px;

  @media (min-width: 600px) {
    gap: ${({ direction }) => (direction === 'row' ? '12px' : '6px')};
  }
`

const Label = styled.div`
  font-weight: 600;
  font-size: 13px;
  line-height: 1.3;

  @media (min-width: 600px) {
    font-size: 14px;
  }
`

const StarsWrapper = styled.div`
  display: flex;
  gap: 6px;
`

export default function RatingGroup({
  label,
  value = 0,
  onChange,
  direction = 'column',
  readOnly = false,
}) {
  const items = [1, 2, 3, 4, 5]

  return (
    <Wrapper direction={direction}>
      <Label>{label}</Label>
      <StarsWrapper>
        {items.map(num => (
          <Star
            key={num}
            filled={num <= value}
            readOnly={readOnly}
            onClick={e => {
              e.stopPropagation()
              if (!readOnly && onChange) onChange(num)
            }}
            onKeyDown={e => {
              e.stopPropagation()
              if (!readOnly && onChange && e.key === 'Enter') onChange(num)
            }}
          />
        ))}
      </StarsWrapper>
    </Wrapper>
  )
}
